import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useState } from 'react';

import {
  statementsItemsSelect,
  statementsRadioItemsSelect,
} from '../../../../../../store/customerDetail/stataments/constants';

import { Header } from './Header';
import { Table } from './Table';

interface StatementsProps {}
interface ShadowWrapperProps {
  children: React.ReactElement;
}

const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children }) => (
  <Shadow level={3} borderRadius={BoxRadius.sm} mt={Spacing['inline.xxs']}>
    {children}
  </Shadow>
);

export const Statements: React.FC<StatementsProps> = () => {
  const [hasStatementsData, setHasStatementsData] = useState(false);

  const Wrapper = useBreakpointValue({
    base: React.Fragment,
    sm: ShadowWrapper,
  });

  return (
    <Wrapper>
      <VStack
        bg={{ base: 'transparent', sm: 'white' }}
        borderRadius={{ base: 'none', sm: BoxRadius.sm }}
        space={{ base: Spacing['stack.xxs'], lg: 0 }}>
        <Box
          zIndex={5}
          p={{
            base: Spacing['inline.nano'],
            sm: Spacing['inline.xxs'],
          }}>
          <Header
            radioOptions={statementsRadioItemsSelect}
            selectOptions={statementsItemsSelect}
            hasData={hasStatementsData}
          />
        </Box>
        <Table onDataChange={setHasStatementsData} />
      </VStack>
    </Wrapper>
  );
};
